module.exports = __webpack_public_path__ + "img/2.95bb4644.png";